import { LoadablePaint } from '@confluence/loadable';

export const LazyWatermarkConfigurationPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-WatermarkConfigurationContainer" */ '../src/WatermarkConfiguration/WatermarkConfigurationPage.tsx'
			)
		).WatermarkConfigurationPage,
});
